module.exports = __webpack_public_path__ + "img/skip-end-btn-fill.b66d5941.svg";